import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import { Link } from '../utils/router/v3Bridge';
import styles from './TextWithIcon.module.scss';

interface TextWithIconProps {
  text: React.ReactNode;
  icon?: React.ReactNode;
  iconPosition?: 'start' | 'end';
  noWrap?: boolean;
  truncate?: 'single' | 'multi';
  to?: string;
}

const TextWithIcon = ({
  text,
  icon,
  iconPosition = 'end',
  noWrap,
  truncate,
  to,
}: TextWithIconProps) => {
  if (truncate) {
    const content = (
      <>
        {iconPosition === 'start' && icon}
        <span
          className={classNames({
            [styles.singleLine]: truncate === 'single',
            [styles.multiLine]: truncate === 'multi',
          })}
        >
          {text}
        </span>
        {iconPosition === 'end' && icon}
      </>
    );
    return (
      <div className={styles.truncate}>
        {to ? <Link to={to}>{content}</Link> : content}
      </div>
    );
  }

  let leadingComponent = iconPosition === 'start' ? icon : text;
  let trailingComponent = iconPosition === 'start' ? text : icon;

  if (typeof text === 'string') {
    if (iconPosition === 'start') {
      const [first, ...remaining] = _.split(text, '');
      const rest = remaining.join('');
      leadingComponent = (
        <span className={styles.wrappingGroup}>
          {icon}
          {first}
        </span>
      );
      trailingComponent = rest;
    } else {
      const chars = _.split(text, '');
      const rest = chars.slice(0, chars.length - 1).join('');
      const last = chars[chars.length - 1];
      leadingComponent = rest;
      trailingComponent = (
        <span className={styles.wrappingGroup}>
          {last}
          {icon}
        </span>
      );
    }
  }

  return (
    <span className={noWrap ? styles.wrappingGroup : styles.wrap}>
      {leadingComponent}
      {trailingComponent}
    </span>
  );
};

export default TextWithIcon;
